<template>
  <div style="padding-bottom: 60px;">
    <!-- 退出登录 -->
    <logOut />
    <div class="title">
      <div :class="border===2?'qiye_ccolor':'qiye'" @click='handleChange(2)'>企业话术库</div>
      <div :class="border===3?'qiye_ccolor':'qiye'" @click='handleChange(3)'>经销商话术库</div>
      <div :class="border===1?'qiye_ccolor':'qiye'" @click='handleChange(1)'>个人话术库</div>
    </div>
    <van-search v-model="keyword" placeholder="搜索" @search="onSearch" @clear="onCancel" shape="round" />
    <div class="search">
      <van-dropdown-menu active-color="#3974c4">
        <van-dropdown-item v-model="deptId" :options="deptList" v-if="border === 3 && deptList.length > 0" />
        <!-- <van-dropdown-item v-model="groupId" :options="GroupList" /> -->
        <van-dropdown-item :title="groupName" ref="item">
          <multipleSelect ref="selectChild" :parentType="border" :deptId="deptId" :dataList="groupList"
            :groupItem="groupItem" @getGroupItem="getGroupItem" @getIdName="getIdName"
            @getShowPopupTree="getShowPopupTree">
          </multipleSelect>
        </van-dropdown-item>
      </van-dropdown-menu>
    </div>
    <!-- <div class="search search-group">
      <van-dropdown-menu active-color="#3974c4">
        <van-dropdown-item v-model="groupId" :options="firstLevelList" />
        <van-dropdown-item v-model="groupId" :options="twoLevelList" />
      </van-dropdown-menu>
    </div> -->
        
    <!-- 内容列表 -->
    <div class="conte" v-for="(item, index) in speechListcontent" :key="index" @click="handleUpd(item)">
      <div style="display:flex;justify-content: space-between;">
        <div>
          <div>{{ item.title }}</div>
          <div style="margin-top: 5px;font-size: 14px; color:#888;" class="content">{{ item.content }}</div>
        </div>
        <div class="copy">发送</div>
      </div>
    </div>
    <div v-if="border === 1" class="content-btn">
      <van-button type="primary" @click="showPopupStaff = true">创建我的话术</van-button>
    </div>
    <!-- popup -->
    <van-popup v-model="showPopup" position="bottom" :style="{ height: '75%' }">
      <div class="popup">
        <van-field class="popup-title" v-model="details.title" input-align="center" rows="1" autosize type="textarea"
          disabled>
        </van-field>
        <van-field class="popup-content" v-model="details.content" rows="1" autosize type="textarea"></van-field>

        <div class="popup-btn">
          <van-button type="primary" @click="handleSave">发送</van-button>
        </div>
      </div>
    </van-popup>

    <staff v-if="showPopupStaff" :groupList="groupList" @getShowPopupStaff="getShowPopupStaff"></staff>
    <van-empty description="暂无更多" v-if="groupList.length < 1 || speechListcontent.length < 1" />
  </div>
</template>

<script>
import staff from '../../components/staff.vue'
import multipleSelect from '../../components/multipleSelect.vue'
import { flatten } from '../../utils/index'
import logOut from "./logOut"

export default {
  props: {
  },
  components: { staff, multipleSelect, logOut },
  data () {
    return {
      selectNum: 0,
      groupName: '',
      showPopupTree: false,
      groupItem: {},
      groupList: [],
      speechListcontent: [],
      active: 0,
      border: 2,
      entry: '',
      groupId: '',
      keyword: '',
      showPopup: false,
      showPopupStaff: false,
      details: {},
      typeList: [
        { text: '企业库', value: 2 },
        { text: '我的库', value: 1 },
        { text: '经销商库', value: 3 },
      ],
      href: {
        corpId: ''
      },
      deptId: null,
      deptList: []
    }
  },
  watch: {
    // border (val) {
    //   this.$refs.selectChild.idList = []
    //   this.$refs.selectChild.twoList = []
    //   this.$refs.selectChild.threeList = []

    //   this.speechgroupList()
    // },
    // groupId (val) {
    //   this.speechList()
    // },
    deptId (val) {
      this.speechgroupList()
    }
  },
  created () {
    this.href.corpId = this.$store.state.auth.corpId

    if (this.border === 3) {
      this.groupList = []
      this.initDeptList()
    } else {
      this.speechgroupList()
    }
    this.getJsSDK()
  },
  methods: {
    handleChange (val) {
      this.border = val
      if (this.border === 3) {
        this.groupList = []
        this.initDeptList()
      } else {
        this.speechgroupList()
      }
    },
    // getGroupItem
    getGroupItem (val) {
      console.log(val, 'val');
      this.groupItem = val
      this.groupId = val.id
      // this.groupName = val.text
      this.speechList()
      if (val.children === null || val.children === undefined) {
        val.children = []
      }
      if (this.selectNum > 0 && val.children.length < 1) {
        this.$refs.item.toggle();
      }
      this.selectNum++
    },
    getIdName (val) {
      this.groupName = val.join('/')
    },
    // getShowPopupTree
    getShowPopupTree (val) {
      this.showPopupTree = val
    },
    onSearch () {
      this.speechList()
    },
    onCancel () {
      this.speechList()
    },
    // getShowPopupStaff
    getShowPopupStaff (val) {
      this.showPopupStaff = val
      if (!val) {
        this.speechgroupList()
        this.speechList()
      }
    },
    handleUpd (item) {
      console.log(item, 'item');

      this.details = item
      this.showPopup = true
    },
    handleSave () {
      console.log(this.details.content, 'this.details')
      wx.invoke('sendChatMessage', {
        msgtype: "text", //消息类型，必填
        text: {
          content: this.details.content, //文本内容
        },
      }, function(res) {
        // alert(res)
        if (res.err_msg == 'sendChatMessage:ok') {
          //发送成功
          console.log(res)
        }
      })
    },
    // // 点击企业库个人库
    // getWareData (item) {
    //   this.border = item.border
    // },
    // 经销商列表
    initDeptList () {
      this.$http
        .get("/scrm/v1/wxcp-chat-tool/p/contentShareDeptMulTenancy", {})
        .then((res) => {
          const { code, data } = res
          if (code === 1) {
            this.deptList = []
            res.data.forEach(item => {

              if (item.deptList === null || item.deptList === undefined) {
                item.deptList = []
              }
              if (item.deptList.length > 0) {
                item.deptList.forEach(tree => {
                  tree.tenancyName = item.tenancy.name || ''
                });
                this.deptList.push(item.deptList)
              }

            })
            this.deptList = flatten(this.deptList);
            console.log(this.deptList, 'this.deptList');
            if (this.deptList.length > 0) {
              this.deptList.forEach(item => {
                item.text = item.tenancyName + '/ ' + item.name
                item.value = item.id
              })
              this.deptId = this.deptList[0].id
              this.speechgroupList()
            } else {
              this.groupItem = {}
              this.groupId = null
              this.groupList = []
              this.groupName = ''
              this.speechListcontent = []
            }
          }
        });
    },
    //查询话术库分组
    speechgroupList () {
      this.$http
        .get("/scrm/v1/wxcp-chat-tool/p/findCtSpeechTreeMul", {
          params: {
            corpId: this.href.corpId,
            owner: this.border,
            deptId: this.deptId
          },
        })
        .then((res) => {
          if (res.code === 1) {
            this.groupList = []
            res.data.forEach(item => {

              if (item.tree === null || item.tree === undefined) {
                item.tree = []
              }
              if (item.tree.length > 0) {
                item.tree.forEach(tree => {
                  tree.tenancyName = item.tenancy.name || ''
                });
                this.groupList.push(item.tree)
              }
            })

            this.groupList = flatten(this.groupList);

            if (this.groupList.length > 0) {
              this.groupItem = this.groupList[0]
              this.groupId = this.groupList[0].id
              this.groupName = this.groupList[0].text
              this.speechList()
            } else {
              this.groupItem = {}
              this.groupId = null
              this.groupName = ''
              this.speechListcontent = []
            }
          }
        });
    },
    //查询话术库内容
    speechList () {
      this.$http
        .get("/scrm/v1/wxcp-chat-tool/p/findCtSpeechListByGroupId", {
          params: {
            corpId: this.href.corpId,
            groupId: this.groupId,
            owner: this.border,
            page: 1,
            pageCount: 10000,
            keyword: this.keyword,
            deptId: this.deptId
          },
        })
        .then((res) => {
          const { code, data } = res
          if (code === 1) {
            if (data !== null) {
              this.speechListcontent = data.records
            }
          }
        })
    },
    getconfig () {
      wx.config({
        beta: true,// 必须这么写，否则wx.invoke调用形式的jsapi会有问题
        debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
        appId: this.config.corpid, // 必填，企业微信的corpID
        timestamp: this.config.timestamp, // 必填，生成签名的时间戳
        nonceStr: this.config.nonceStr, // 必填，生成签名的随机串
        signature: this.config.signature,// 必填，签名，见 附录-JS-SDK使用权限签名算法
        jsApiList: ['agentConfig'], // 必填，需要使用的JS接口列表，凡是要调用的接口都需要传进来
      })
      let that = this
      wx.ready(function() {
        wx.agentConfig({
          corpid: that.config.corpid, // 必填，企业微信的corpid，必须与当前登录的企业一致
          agentid: that.config.agentId, // 必填，企业微信的应用id （e.g. 1000247）
          timestamp: that.config.timestamp, // 必填，生成签名的时间戳
          nonceStr: that.config.nonceStr, // 必填，生成签名的随机串
          signature: that.config.agentSignature,// 必填，签名，见附录-JS-SDK使用权限签名算法
          jsApiList: ['selectExternalContact', 'getContext', 'sendChatMessage'], //必填
          success: function(res) {
            // 回调
            console.log(res);
            console.log(123456789)
            wx.invoke('getContext', {
            }, function(res) {
              console.log(res)
              if (res.err_msg == "getContext:ok") {
                this.entry = res.entry; //返回进入H5页面的入口类型，目前有normal、contact_profile、single_chat_tools、group_chat_tools
                console.log(res)
              } else {
                //错误处理
              }
            })
          },
          fail: function(res) {
            console.log(res, 'fail')
            if (res.errMsg.indexOf('function not exist') > -1) {
              alert('版本过低请升级')
            }
          }
        })

      })

    },
    selectSpeech (item) {
      console.log(item);
      wx.invoke('sendChatMessage', {
        msgtype: "text", //消息类型，必填
        text: {
          content: item.content, //文本内容
        },
      }, function(res) {
        // alert(res)
        if (res.err_msg == 'sendChatMessage:ok') {
          //发送成功
          console.log(res)
        }
      })

    },
    //获取jsSDK信息
    getJsSDK () {
      this.$http.get('/scrm/v1/wxcp-corp/p/getJsSDK', {
        params: {
          corpId: this.href.corpId,
          url: window.location.href.split('#')[0] //'http://scrm-wxwork-ui.ngrok.gznino.com:8080/'
        }
      }).then(res => {
        if (res.code === 1) {
          this.config = res.data
          this.getconfig()
        }
      })
    },
  },
};
</script>
 
<style lang="less" scoped>
.conte {
  line-height: 20px;
  padding: 15px 20px 15px 15px;
  font-size: 14px;
  border-bottom: 1px solid #ccc;
  cursor: pointer;
}
.popup {
  padding-bottom: 65px;
  .popup-title {
    padding: 18px 20px;
    font-weight: bold;
    font-size: 16px;
  }
  /deep/ .van-field__control:disabled {
    color: #323233;
    -webkit-text-fill-color: #323233;
  }
  .popup-content {
    padding: 18px 16px;
    font-size: 14px;
    line-height: 24px;
  }
  .popup-btn {
    position: fixed;
    bottom: 0;
    z-index: 999;
    width: 100%;
    /deep/.van-button--primary {
      width: 100%;
      background-color: #3974c4;
      border: 0;
      line-height: 45px;
      height: 45px;
    }
  }
}
.content-btn {
  position: fixed;
  bottom: 0;
  width: 100%;
  z-index: 1;
  /deep/.van-button--primary {
    width: 100%;
    background-color: #3974c4;
    border: 0;
    line-height: 45px;
    height: 45px;
  }
}
.search {
  width: 100%;
  padding: 0 10px 0 5px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  /deep/ .van-dropdown-menu {
    width: 100%;
  }
  /deep/ .van-dropdown-menu__bar {
    // width: 80px;
    display: flex;
    justify-content: space-between;
    box-shadow: 0 0;
    font-size: 15px;
  }
  /deep/.van-search {
    width: 70%;
  }
}
.search-group {
  /deep/ .van-dropdown-menu__bar {
    width: 200px;
    display: flex;
    justify-content: space-between;
    box-shadow: 0 0;
    font-size: 15px;
  }
  /deep/ .van-dropdown-menu__title::after {
    // right: -0.10667rem;
    margin-top: -0.16rem;
    border: 0.11rem solid;
    border-color: transparent transparent #3974c4 #3974c4;
  }
}

.content {
  word-break: break-all;
  text-overflow: -o-ellipsis-lastline;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  line-clamp: 3;
  -webkit-box-orient: vertical;
}
.copy {
  width: 45px;
  height: 25px;
  min-width: 45px;
  margin-left: 10px;
  border: 1px solid #3974c4;
  color: #3974c4;
  font-size: 13px;
  border-radius: 15px;
  text-align: center;
  line-height: 25px;
}
.title {
  padding: 10px 20px;
  font-size: 14px;
  display: flex;
  border-bottom: 1px solid #dedede;
  .qiye {
    width: 100px;
    height: 30px;
    background-color: #f0f0f2;
    text-align: center;
    line-height: 30px;
    border-radius: 18px;
    margin-right: 10px;
  }
  .qiye_ccolor {
    width: 100px;
    height: 30px;
    background-color: #e6e6ff;
    border: 1px solid #9494e8;
    text-align: center;
    line-height: 30px;
    border-radius: 18px;
    margin-right: 10px;
  }
}
</style>
